import React, { useState } from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import { Location } from '@reach/router'
import axios from 'axios'

import { FacebookShareButton, TwitterShareButton } from 'react-share'
import { IoLogoFacebook, IoLogoTwitter } from 'react-icons/io'

import BaseLayout from '@layouts/BaseLayout'
import Header from '@components/Header'

import styles from './styles.module.scss'
import SEO from '@components/SEO'

export default ({ data }) => {
  const { markdownRemark: article } = data
  const { edges: relatedArticles } = data.relatedArticles

  const [fbShareCount, setFbShareCount] = useState(0)

  const getFacebookShareCount = (shareUrl, callback) => {
    const endpoint = `https://graph.facebook.com/?id=${ shareUrl }&fields=engagement&access_token=2428249110600404|pUi9Re_6F5OlA7gvIEQXiZeWkC0`

    axios.get(endpoint)
      .then(({ data }) => {
        callback(data && data.engagement && data.engagement.share_count
          ? data.engagement.share_count
          : 0)
      })
  }

  return (
    <BaseLayout className={styles.articleLayout}>
      <Location>
        {({ location }) => (
          <SEO
            title={article.frontmatter.title}
            description={data.description.excerpt}
            pathName={location.pathname.replace('/elmina-grove', '')}
            image={article.frontmatter.featuredImage.childImageSharp.fluid.src.replace('/elmina-grove', '')}
          />
        )}
      </Location>

      <Header />

      <article className="section">
        <div className="container">
          <section className={styles.contentSection}>
            <header>
              <div className={styles.metadata}>
                <span>{article.frontmatter.tag}</span>
                <span>{article.frontmatter.date}</span>
              </div>

              <div className={styles.title}>
                <h1>{article.frontmatter.title}</h1>
              </div>

              {article.frontmatter.featuredImage.name !== 'placeholder' &&
                <div className={styles.featuredImage}>
                  <Img fluid={article.frontmatter.featuredImage.childImageSharp.fluid} />
                  <p>{article.frontmatter.featuredImageCaption}</p>
                </div>
              }

              <div
                className={styles.content}
                dangerouslySetInnerHTML={{ __html: article.html }}
              />
            </header>
          </section>

          <section className={styles.footer}>
            <Location>
              {({ location }) => (
                <div>
                  <FacebookShareButton className={styles.shareButtonFacebook} url={location.href}>
                    <div className={styles.buttonBox}>
                      <IoLogoFacebook />
                      <span>Share</span>
                    </div>
                    <div className={styles.shareCount}>
                      {getFacebookShareCount(location.href, value => setFbShareCount(value || 0))}
                      {fbShareCount}
                    </div>
                  </FacebookShareButton>

                  <TwitterShareButton className={styles.shareButtonTwitter} url={location.href}>
                    <div className={styles.buttonBox}>
                      <IoLogoTwitter />
                      <span>Tweet</span>
                    </div>
                  </TwitterShareButton>
                </div>
              )}
            </Location>

            {relatedArticles.length > 0 &&
              <div className={styles.footerTitle}>
                <h2>You might also like</h2>
              </div>
            }

            <div className={styles.relatedArticles}>
              {relatedArticles.map(({ node }, index) => (
                <div className="columns" key={index}>
                  <div className="column is-4">
                    <Link to={node.fields.slug}>
                      <Img fluid={node.frontmatter.featuredImage.childImageSharp.fluid} />
                      <h3>{node.frontmatter.title}</h3>
                    </Link>
                  </div>
                </div>
              ))}

              <Link className={styles.backToAll} to="/whats-new">View All Stories</Link>
            </div>
          </section>
        </div>

      </article>
    </BaseLayout>
  )
}

export const pageQuery = graphql`
  query articleById($id: String!, $relatedTag: String!) {
    # Get main article content
    markdownRemark(id: {eq: $id}) {
      id
      html
      excerpt(format: HTML)
      frontmatter {
        title
        tag
        featuredImage {
          name
          childImageSharp {
            fluid(quality: 80, maxWidth: 1440) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        featuredImageCaption
        date(formatString: "DD MMMM YYYY")
      }
    }

    description: markdownRemark(id: {eq: $id}) {
      excerpt(format: PLAIN)
    }

    # Get related post
    relatedArticles: allMarkdownRemark(
      filter: {
        id: {ne: $id}
        frontmatter: {
          tag: {eq: $relatedTag}
        }
      }
      ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            featuredImage {
              childImageSharp {
                fluid(quality: 80, maxWidth: 500) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
